export const ProfileConstants = {
    GET_VEHICLE_LIST: "GET_VEHICLE_LIST",
    ADD_NEW_VEHICLE:"ADD_NEW_VEHICLE",
    ADD_NEW_DRIVER:"ADD_NEW_DRIVER"
  };